import { ConsoleHeaderSelect } from '../../../components/shared/console/ConsoleHeaderSelect';
import type { OrderModeFilter } from '../models/types';

const MODE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'sandbox', label: 'Sandbox' },
  { value: 'live', label: 'Live' },
] as const;

type TransactionModeSelectProps = {
  value: OrderModeFilter;
  onChange: (value: OrderModeFilter) => void;
  disabled?: boolean;
};

export default function TransactionModeSelect({
  value,
  onChange,
  disabled,
}: TransactionModeSelectProps) {
  return (
    <ConsoleHeaderSelect
      value={value}
      options={[...MODE_OPTIONS]}
      onChange={(next) => onChange(next as OrderModeFilter)}
      disabled={disabled}
      aria-label="Filter by sandbox or live transactions"
      minWidthClass="min-w-[7.5rem]"
    />
  );
}
